import React, { useEffect } from "react";
import { useLocation } from "react-router";
const ScrollToTop = ({ children }) => {
    const location = useLocation();
    useEffect(() => {
        const scrollingElement = document.querySelector("#page-wrapper");
        if (scrollingElement) {
            scrollingElement.scrollTop = 0;
        }
        document.body.scrollTop = 0;
    }, [location.pathname]);
    return React.createElement(React.Fragment, null, children);
};
export default ScrollToTop;
